import React, {useCallback, useEffect, useState} from 'react';

import {Button, Icon, IconSize} from 'components';
import {screenUtils} from 'utils';

type Props = {
    onClick: React.MouseEventHandler<HTMLButtonElement>
}

export const LeaveSessionButton: React.FC<Props> = ({onClick}) => {
    const [iconSize, setIconSize] = useState<IconSize>('4xl');

    const handleResize = useCallback(() => {
        setIconSize(screenUtils.isLessSm() || screenUtils.isLandscape() && screenUtils.isLessLg() ?
            '2xl' : '4xl');
    }, []);

    useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    return (
        <Button
            color='attention'
            width='auto'
            height='auto'
            rounded
            onClick={onClick}
        >
            <Icon name='phone-end' size={iconSize} />
        </Button>
    );
};